export default {
  acceptedshipment: {
    title: "Comparison Report of the Shipments",
    period: "Period",
    periodNotSelected: "The period field cannot be empty"
  }
};
